<template v-once>
  <ValidationObserver ref="form">

    <b-row>
      <b-col sm="12">
        <h5 class="h5-color">
          <span class="header-icon"><i class="nav-icon icon-direction"></i></span>
          Your Cover Details
        </h5>
      </b-col>
    </b-row>


    <ValidationProvider
        vid="cover_type"
        name="Cover Type"
        v-slot="{ errors }"
        rules=""
    >
      <b-row class="row-bottom">
        <b-col sm="8" md="8">
          <label class="label-name">Cover Type <span style="color:red">*</span></label>
          <b-form-group>
            <b-row>
              <!-- Title -->
              <b-col md="12" class="">
                <v-select
                    label="name"
                    @input="setCoverType"
                    :options="cover_type_list"
                    :reduce="data => data.code"
                    :value="CoverData.cover_type"
                    placeholder="--PLEASE SELECT--"
                ></v-select>
              </b-col>
            </b-row>
          </b-form-group>
        </b-col>
        <b-col cols="12" sm="4">
          <label class="label-name empty-label"></label>
          <div class="msg validation-form-msg required-msg" v-if="!errors[0]">
            <span class="msg-paragraph"><span style="color:red">*</span>This field is required</span>
          </div>
          <div v-else class="msg-fail validation-form-msg">
                      <span class="msg-paragraph" v-for="(error, index) in errors" v-bind:key="index">
                        {{ error }}
                      </span>
          </div>
        </b-col>
      </b-row>
    </ValidationProvider>

    <ValidationObserver ref="cover_table">
      <!--Cover Table-->
      <div class="table-responsive">
        <table class="table table-striped table-bordered cover-data-table">
          <thead>
          <th class="cover-name-header-slot"> Cover Exist</th>
          <th class="cover-name-header-slot">Cover Name</th>
          </thead>
          <tr v-if="CoverList.length == 0">
            <td colspan="3">No data</td>
          </tr>
          <tr v-for="(cover, index) in CoverList">
            <td>
              <p-radio :disabled="cover.mandatory_or_optional == 'Mandatory' || cover.disabled" class="p-default p-curve p-bigger"
                       @change="draftCoverTable(cover , 1)" v-model="cover.checked"
                       :value="1" color="primary-o">Yes
              </p-radio>
              <p-radio :disabled="cover.mandatory_or_optional == 'Mandatory' || cover.disabled" class="p-default p-curve p-bigger"
                       @change="draftCoverTable(cover , 0)" v-model="cover.checked"
                       :value="0" color="danger-o">No
              </p-radio>
            </td>

            <td class="cover-name-slot" v-bind:class="{ mandatary_class: cover.mandatory_or_optional == 'Mandatory' }">
              {{ cover.cover_name.toUpperCase() }}
              <div v-if="cover.is_value == 1">
                <div v-if="cover.cover_code == 'M03'">
                  <ValidationProvider
                      :vid="cover.cover_code"
                      name="Cover Value"
                      v-slot="{ errors }"
                      :rules="{ required: cover.checked == 1 }">
                    <v-select
                        :options="filterGlobalCfg('M03')"
                        v-model="cover.value_required"
                        @input="draftCoverTable"
                        label="Select or add Colors"
                        auto prepend-icon="map"
                        hide-details
                        id="langSelect"
                        :disabled="!cover.checked"
                    ></v-select>
                    <span class="under-error-messages" v-for="(error, index) in errors" v-bind:key="index">
                                        {{ error }}
                                    </span>
                  </ValidationProvider>

                </div>
                <div v-else-if="cover.cover_code == 'M07'">
                  <ValidationProvider
                      :vid="cover.cover_code"
                      name="Cover Value"
                      v-slot="{ errors }"
                      :rules="{ required: cover.checked == 1 }">
                    <v-select
                        :options="filterGlobalCfg('M07')"
                        v-model="cover.value_required"
                        @input="draftCoverTable"
                        label="Select or add Colors"
                        auto prepend-icon="map"
                        hide-details
                        id="langSelect"
                        :disabled="!cover.checked"
                    ></v-select>
                    <span class="under-error-messages" v-for="(error, index) in errors" v-bind:key="index">
                                        {{ error }}
                                    </span>
                  </ValidationProvider>
                </div>
                <div v-else-if="cover.cover_code == 'M32'">

                  <ValidationProvider
                      :vid="cover.cover_code"
                      name="Driver Name"
                      v-slot="{ errors }"
                      :rules="{ required: cover.checked == 1 }">
                    <label>Please enter the name</label>

                    <b-form-input
                        type="text"
                        size="md"
                        placeholder="Enter Name"
                        v-model="cover.full_name"
                        @change="draftCoverTable"
                        :disabled="!cover.checked">
                    </b-form-input>

                    <span class="under-error-messages" v-for="(error, index) in errors" v-bind:key="index">
                                        {{ error }}
                                    </span>
                  </ValidationProvider>

                  <br>

                  <ValidationProvider
                      :vid="cover.cover_code"
                      name="Driver DOB"
                      v-slot="{ errors }"
                      :rules="{ required: cover.checked == 1 }">
                    <label>Please enter the dob</label>

                    <b-form-input
                        type="date"
                        size="md"
                        placeholder="Enter DOB"
                        v-model="cover.dob"
                        @change="draftCoverTable"
                        :disabled="!cover.checked">
                    </b-form-input>

                    <span class="under-error-messages" v-for="(error, index) in errors" v-bind:key="index">
                                        {{ error }}
                                    </span>
                  </ValidationProvider>
                </div>
                <div v-else-if="cover.cover_code == 'M37'">
                  <ValidationProvider
                      :vid="cover.cover_code"
                      name="Cover Value"
                      v-slot="{ errors }"
                      :rules="{ required: cover.checked == 1 }">
                    <v-select
                        :options="filterGlobalCfg('M37')"
                        v-model="cover.value_required"
                        @input="draftCoverTable"
                        label="Select or add Colors"
                        auto prepend-icon="map"
                        hide-details
                        id="langSelect"
                        :disabled="!cover.checked"
                    ></v-select>
                    <span class="under-error-messages" v-for="(error, index) in errors" v-bind:key="index">
                                        {{ error }}
                                    </span>
                  </ValidationProvider>
                </div>

                <div v-else-if="GlobalCfg['validation_covers'].indexOf( (cover.cover_code.trim()) ) >= 0">
                  <ValidationProvider
                      :vid="cover.cover_code"
                      name="Cover Value"
                      v-slot="{ errors }"
                      :rules="getCoverValidation(cover.cover_code , cover.checked)">
                    <b-form-input
                        type="number"
                        size="md"
                        placeholder="Enter Value"
                        v-model="cover.value_required"
                        @change="draftCoverTable"
                        :disabled="!cover.checked">
                    </b-form-input>
                    <span class="under-error-messages" v-for="(error, index) in errors" v-bind:key="index">
                                        {{ error }}
                                    </span>
                  </ValidationProvider>
                </div>
                <div v-else-if="cover.cover_code == 'M33'">
                  <ValidationProvider
                      :vid="cover.cover_code"
                      name="Cover Value"
                      v-slot="{ errors }"
                      :rules="returnDecimalValidation(cover)">
                    <b-form-input
                        type="number"
                        size="md"
                        placeholder="Enter Value"
                        v-model="cover.value_required"
                        @change="draftCoverTable"
                        :disabled="!cover.checked">
                    </b-form-input>
                    <span class="under-error-messages" v-for="(error, index) in errors" v-bind:key="index">
                                        {{ error }}
                                    </span>
                  </ValidationProvider>
                </div>

                <div v-else-if="cover.cover_code == 'M54'">
                  <ValidationProvider
                      :vid="cover.cover_code"
                      name="Cover Value"
                      v-slot="{ errors }"
                      :rules="returnDecimalValidation(cover)">
                    <b-form-input
                        type="number"
                        size="md"
                        placeholder="Enter Value"
                        v-model="cover.value_required"
                        @change="draftCoverTable"
                        :disabled="!cover.checked">
                    </b-form-input>
                    <span class="under-error-messages" v-for="(error, index) in errors" v-bind:key="index">
                                        {{ error }}
                                    </span>
                  </ValidationProvider>
                </div>

                <div v-else-if="cover.cover_code == 'NATURE_OF_GOODS' ">

                  <ValidationProvider
                      :vid="cover.cover_code"
                      name="Cover Value"
                      v-slot="{ errors }"
                      :rules="{ required: cover.checked == 1 }">
                    <b-form-input
                        type="text"
                        size="md"
                        placeholder="Enter Value"
                        v-model="cover.value_required"
                        @change="draftCoverTable"
                        :disabled="!cover.checked">
                    </b-form-input>
                    <span class="under-error-messages" v-for="(error, index) in errors" v-bind:key="index">
                                        {{ error }}
                                    </span>
                  </ValidationProvider>

                  <ValidationProvider
                      :vid="cover.cover_code"
                      name="Goods Value"
                      v-slot="{ errors }"
                      :rules="{ required: cover.checked == 1 }">
                    <label>Goods Value</label>

                    <b-form-input
                        type="number"
                        size="md"
                        placeholder="Enter Goods Value"
                        v-model="cover.goods_value"
                        @change="draftCoverTable"
                        :disabled="!cover.checked">
                    </b-form-input>

                    <span class="under-error-messages" v-for="(error, index) in errors" v-bind:key="index">
                                        {{ error }}
                                    </span>
                  </ValidationProvider>

                </div>

                <div v-else>
                  <!--                                    <b-form-input-->
                  <!--                                            type="text"-->
                  <!--                                            size="md"-->
                  <!--                                            placeholder="Enter Value"-->
                  <!--                                            v-model="cover.value_required"-->
                  <!--                                            @change="draftCoverTable"-->
                  <!--                                            :disabled="!cover.checked">-->
                  <!--                                    </b-form-input>-->
                </div>

              </div>
            </td>

          </tr>
        </table>
      </div>
      <!--End of cover table-->
    </ValidationObserver>

    <ValidationProvider
        vid="cover_period_from"
        name="Cover Date"
        v-slot="{ errors }"
        rules=""
    >
      <b-row class="row-bottom">
        <b-col sm="8" md="8">
          <label class="label-name">Cover Date <span style="color:red">*</span></label>
          <b-form-group>
            <b-row>
              <!-- Passport Number -->
              <b-col md="12" class="">
                <b-form-input
                    v-model="CoverData.cover_period_from"
                    type="date"
                    id="input-large"
                    size="lg"
                    placeholder="Cover Date"
                    @change="draftProposalData"
                ></b-form-input>
                <span style="color:#ffc107;font-size: 11px;"
                >Valid only for one year.</span>
              </b-col>
            </b-row>
          </b-form-group>
        </b-col>
        <b-col cols="12" sm="4">
          <label class="label-name empty-label"></label>
          <div class="msg validation-form-msg required-msg" v-if="!errors[0]">
            <span class="msg-paragraph"><span style="color:red">*</span>This field is required</span>
          </div>
          <div v-else class="msg-fail validation-form-msg">
              <span class="msg-paragraph" v-for="(error, index) in errors" v-bind:key="index">
                {{ error }}
              </span>
          </div>
        </b-col>
      </b-row>
    </ValidationProvider>

    <!--        <ValidationProvider-->
    <!--                vid="cover_period_to"-->
    <!--                name="Period of cover(To)"-->
    <!--                v-slot="{ errors }"-->
    <!--                rules=""-->
    <!--        >-->
    <!--            <b-row class="row-bottom">-->
    <!--                <b-col sm="8" md="8">-->
    <!--                    <label class="label-name">Period of cover(To)</label>-->

    <!--                    <b-form-group>-->
    <!--                        <b-row>-->
    <!--                            &lt;!&ndash; Passport Number &ndash;&gt;-->
    <!--                            <b-col md="12" class="">-->
    <!--                                <b-form-input-->
    <!--                                        v-model="CoverData.cover_period_to"-->
    <!--                                        type="date"-->
    <!--                                        id="input-large"-->
    <!--                                        size="lg"-->
    <!--                                        placeholder="Cover Period To"-->
    <!--                                        @change="draftProposalData"-->
    <!--                                ></b-form-input>-->
    <!--                            </b-col>-->
    <!--                        </b-row>-->
    <!--                    </b-form-group>-->
    <!--                </b-col>-->
    <!--                <b-col cols="12" sm="4">-->
    <!--                    <label class="label-name empty-label"></label>-->
    <!--                    <div class="msg validation-form-msg required-msg" v-if="!errors[0]">-->
    <!--                        <span class="msg-paragraph"><span style="color:red">*</span>This field is required</span>-->
    <!--                    </div>-->
    <!--                    <div v-else class="msg-fail validation-form-msg">-->
    <!--                      <span class="msg-paragraph" v-for="(error, index) in errors" v-bind:key="index">-->
    <!--                        {{ error }}-->
    <!--                      </span>-->
    <!--                    </div>-->
    <!--                </b-col>-->
    <!--            </b-row>-->
    <!--        </ValidationProvider>-->

    <ValidationProvider
        vid="bear_first_portion_accident_claim"
        name="Do you wish to bear first portion of an Accident Claim"
        v-slot="{ errors }"
        rules="">

      <b-row class="term-section">
        <b-col md="3">
          <label class="label-name-cover">
            Do you wish to bear first portion of an Accident Claim <span style="color:red">*</span>
          </label>
        </b-col>

        <b-col md="5">
          <p-radio class="p-default p-curve p-bigger" v-model="CoverData.bear_first_portion_accident_claim" :value="1"
                   name="bear_first_portion_accident_claim" color="primary-o">Yes
          </p-radio>
          <p-radio class="p-default p-curve p-bigger" v-model="CoverData.bear_first_portion_accident_claim" :value="0"
                   name="bear_first_portion_accident_claim" color="danger-o">No
          </p-radio>
        </b-col>

        <b-col md="4">
          <label class="label-name empty-label"></label>
          <div class="msg validation-form-msg required-msg agreement-validation-custom" v-if="!errors[0]">
            <span class="msg-paragraph"><span style="color:red">*</span>This field is required</span>
          </div>
          <div v-else class="msg-fail validation-form-msg agreement-validation-custom">
              <span class="msg-paragraph" v-for="(error, index) in errors" v-bind:key="index">
                {{ error }}
              </span>
          </div>
        </b-col>
      </b-row>
    </ValidationProvider>

    <ValidationProvider
        vid="first_portion_accident_claim_value"
        name="First portion of an Accident Claim Value"
        v-slot="{ errors }"
        rules=""
        v-if="CoverData.bear_first_portion_accident_claim == 1">

      <b-row class="term-section">
        <b-col md="3">
          <label class="label-name-cover">
            First portion of an Accident Claim Value
          </label>
        </b-col>

        <b-col md="5">
          <v-select
              :options="GlobalCfg['first_portion_of_accident']"
              v-model="CoverData.first_portion_accident_claim_value"
              label="Select or add Colors"
              auto prepend-icon="map"
              placeholder="--PLEASE SELECT--"
          ></v-select>
        </b-col>

        <b-col md="4">
          <label class="label-name empty-label"></label>
          <div class="msg validation-form-msg required-msg agreement-validation-custom" v-if="!errors[0]">
                <span class="msg-paragraph">
                    <span style="color:red">*</span>This field is required
                </span>
          </div>
          <div v-else class="msg-fail validation-form-msg agreement-validation-custom">
                        <span class="msg-paragraph"
                              v-for="(error, index) in errors"
                              v-bind:key="index">
                          {{ error }}
                        </span>
          </div>
        </b-col>
      </b-row>
    </ValidationProvider>

    <ValidationProvider
        vid="no_cliam_bounus_years"
        name="No Claim Bonus Years"
        v-slot="{ errors }"
        rules=""
    >
      <b-row class="row-bottom">
        <b-col sm="8" md="8">
          <label class="label-name">If you are entitled to ‘ No Claim Bonus’, please indicate the number of
            years <span style="color:red">*</span></label>
          <b-form-group>
            <b-row>
              <!-- Passport Number -->
              <b-col md="12" class="">
                <v-select
                    :options="GlobalCfg['no_claim_bonus_years']"
                    v-model="CoverData.no_cliam_bounus_years"
                    label="Select"
                    auto prepend-icon="map"
                    placeholder="--PLEASE SELECT--"
                ></v-select>
              </b-col>
            </b-row>
          </b-form-group>
        </b-col>
        <b-col cols="12" sm="4">
          <label class="label-name empty-label"></label>
          <div class="msg validation-form-msg required-msg" v-if="!errors[0]">
                <span class="msg-paragraph">
                    <span style="color:red">*</span>This field is required
                </span>
          </div>
          <div v-else class="msg-fail validation-form-msg">
                <span class="msg-paragraph" v-for="(error, index) in errors" v-bind:key="index">
                  {{ error }}
                </span>
          </div>
        </b-col>
      </b-row>
    </ValidationProvider>


  </ValidationObserver>
</template>

<script>
import {mapState, mapActions} from "vuex";
import multiselect from "vue-multiselect";

export default {
  data: () => {
    return {};
  },
  props: ["error_tab_info"],

  computed: {
    ...mapState("proposal", [
      "CoverData", "cover_type_list", "CoverList", "GlobalCfg", "subLineCode"
    ])
  },
  created() {
  },
  methods: {
    ...mapActions("proposal", [
      "setCoverType",
      "getParameterDataList",
      "getCoverList",
      "setCoverList",
      "draftProposalData",
      "draftCoverData",
      "getConfigValues"
    ]),

    getCoverObj(cover_code_parm){
      return this.CoverList.filter(function(coverObj) {
        return coverObj.cover_code == cover_code_parm;
      });
    },

    filterGlobalCfg(cover_code) {
      if (this.GlobalCfg['dropdown'][cover_code][this.subLineCode]) {
        return this.GlobalCfg['dropdown'][cover_code][this.subLineCode];
      } else {
        return [];
      }

    },
    getCoverValidation(cover_code, checked) {
      if (this.GlobalCfg['validation'][cover_code][this.subLineCode]) {
        let required_cnd = checked ? 'required' : '';
        return required_cnd + '|' + 'between: ' + this.GlobalCfg['validation'][cover_code][this.subLineCode][0] + ' , ' + this.GlobalCfg['validation'][cover_code][this.subLineCode][1] + ' ';
      } else {
        return '';
      }
    },
    returnDecimalValidation(cover) {
      if (cover) {
        let required_cnd = cover.checked ? 'required' : '';
        return required_cnd + '|' + 'decimal';
      } else {
        return '';
      }
    },
    draftCoverTable(cover, type) {
      if (cover && type == 0) {
        cover.value_required = '';
        cover.full_name = '';
        cover.dob = null;
      }

      if(cover && cover.cover_code){
        let cover_code = cover.cover_code;
        if(cover_code == "M30"){
          if(!cover.checked){
            this.getCoverObj("M30T")[0].checked = 0;
            this.getCoverObj("M30T")[0].disabled = true;
          }else{
            this.getCoverObj("M30T")[0].disabled = false;
          }
        }
        if(cover_code == "M30T"){
          if(this.getCoverObj("M30")[0].checked == 0){
            cover.disabled = true;
          }else{
            cover.disabled = false;
          }
        }
      }

      this.$refs.cover_table.validate().then(valid => {
        if (valid) {
          this.draftCoverData();
        } else {
          // this.$snotify
          //     .error('Please correct your cover data errors', "", {
          //       position: "centerTop",
          //     }).on("destroyed", () => {
          // });
        }
      });
    },
    offClickResetData(cover) {
      cover.value_required = '';
    }
  },

  mounted: function () {

  },
  watch: {
    'CoverData.cover_type': function (val, oldval) {
      this.getCoverList().then((response) => {
        if (response.data.errors) {
          this.$snotify
              .error(response.data.errors.message, "", {
                position: "centerTop",
              }).on("destroyed", () => {
            this.draftCoverTable();
          });
        } else {
          this.setCoverList(response.data).then(() => {
            this.draftProposalData();
            this.draftCoverTable();
          });
        }
      });
    },
    'CoverData.first_portion_accident_claim_value': function (val, oldval) {
      this.draftProposalData();
    },
    'CoverData.no_cliam_bounus_years': function (val, oldval) {
      this.draftProposalData();
    },
    'CoverData.bear_first_portion_accident_claim': function (val, oldval) {
      if (val == 0) {
        this.CoverData.first_portion_accident_claim_value = '';
      }
      this.draftProposalData();
    },
  },

};
</script>

<style scoped>

.to-uppercase {
  text-transform: uppercase
}

div textarea {
  text-transform: uppercase
}

/*.cover-name-header-slot{*/
/*    font-weight: bold;*/
/*    background-color: #f0f3f5 !important;*/
/*}*/

.cover-name-slot {
  color: #31607b;
  font-weight: bold;
}

.mandatary_class {
  background-color: #044066;
  color: white;
}

.under-error-messages {
  color: #dd2f2f;
  font-weight: bold;
  font-size: 12px;
}

.agreement-validation-custom {
  margin-top: -20px !important;
}

input::placeholder {
  font-size: 14px;
}


.msg-secound-line {
  margin-top: 0px;
}

.custom-select {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
}


.hide {
  display: none;
}

.selected_val {
  color: #fff !important;
  background-color: #4b78be !important;
}

p {
  color: #717887;
  margin-top: -15px;
  margin-left: 2px;
}

.check {
  opacity: 0.5;
  color: #996;
}

.box {
  margin-bottom: 5px;
}


img {
  width: 100px;
}

.img-thumbnail {
  border: 1px solid #4b78be !important;
  background-color: #ffffff !important;
}

.btn-outline {
  border: 1px solid #4b78be !important;
}

.btn-pad {
  padding: 0 !important;
}

.btn {
  border: solid 0px #e4e7ea;
  border-radius: 0.3rem !important;
}

.btn-sq {
  width: 98px !important;
  height: 66px !important;
  font-size: 12px;
  color: #4b78be;
  background-color: #ffffff;
  margin-top: 2px;
}

.btn-sqw {
  width: 98px !important;
  height: 105px !important;
  font-size: 12px;
  color: #4b78be;
  background-color: #ffffff;
  margin-top: 2px;
}

.btn-ch {
  width: 55px !important;
  height: 58px !important;
  font-size: 12px;
  color: #4b78be;
  background-color: #ffffff;
}

.label-name {
  font-weight: bold;
  color: #31607b;
  margin-bottom: 15px !important;
}

.label-name-cover {
  font-weight: bold;
  color: #31607b;
  margin-bottom: 15px !important;
}

.label-align {
  text-align: right;
}

hr {
  margin-top: 1px !important;
  margin-bottom: 20px !important;
}

/* start of validation msg css */

.msg {
  border: 1px solid #d8e1eb;
  border-radius: 0.2rem;
  padding: 12px;
  background: #f2f6fa;
  margin-bottom: 18px;
  color: #656d7d;
}

.msg-fail {
  border: 1px solid #ff969b;
  border-radius: 0.2rem;
  padding: 12px;
  background: #ffeef3;
  margin-bottom: 18px;
  color: #ff303a;
}

.msg-success {
  border: 1px solid #6ac879;
  border-radius: 0.2rem;
  padding: 12px;
  background: #eeffed;
  margin-bottom: 18px;
  color: #009b0a;
}

/* end ofvalidation msg css */

.msg-paragraph {
  font-size: 12px;
}

.msg-paragraph-con {
  color: #656d7d;
  font-size: 12px;
  margin-top: -15px;
}

.msg-paragraph-con2 {
  color: #656d7d;
  font-size: 12px;
  margin-top: 15px;
}

.form-text-align {
  text-align: center;
}

.country-header {
  margin-left: 26px;
}

span.individual {
  background: url("~@/assets/icon/user.svg") no-repeat top left;
  background-size: contain;
  cursor: pointer;
  display: inline-block;
  height: 20px;
  width: 100%;
  margin-top: 12px;
  margin-bottom: 12px;
  margin-left: 9px;
}

span.family {
  background: url("~@/assets/icon/family.svg") no-repeat top left;
  background-size: contain;
  cursor: pointer;
  display: inline-block;
  height: 20px;
  width: 100%;
  margin-top: 12px;
  margin-bottom: 12px;
  margin-left: 9px;
}

span.group {
  background: url("~@/assets/icon/group.svg") no-repeat top left;
  background-size: contain;
  cursor: pointer;
  display: inline-block;
  height: 20px;
  width: 100%;
  margin-top: 12px;
  margin-bottom: 12px;
  margin-left: 5px;
}

span.single {
  background: url("~@/assets/icon/plane.svg") no-repeat top left;
  background-size: contain;
  cursor: pointer;
  display: inline-block;
  height: 20px;
  width: 100%;
  margin-top: 12px;
  margin-bottom: 12px;
  margin-left: 12px;
}

span.multi {
  background: url("~@/assets/icon/planes.svg") no-repeat top left;
  background-size: contain;
  cursor: pointer;
  display: inline-block;
  height: 20px;
  width: 100%;
  margin-top: 12px;
  margin-bottom: 12px;
  margin-left: 2px;
}

span.world {
  background: url("~@/assets/icon/world.svg") no-repeat top left;
  background-size: contain;
  cursor: pointer;
  display: inline-block;
  height: 30px;
  width: 40px;
  margin-top: 5px;
  margin-bottom: 0px;
  margin-left: 10px;
}

span.fourty-five {
  /*background: url("~@/assets/icon/calendar.svg") no-repeat top left;*/
  background-size: contain;
  cursor: pointer;
  display: inline-block;
  height: 25px;
  width: 60px;
  margin-top: 2px;
  margin-bottom: 0px;
  margin-left: 1px;
}

span.ninety {
  /*background: url("~@/assets/icon/calendar.svg") no-repeat top left;*/
  background-size: contain;
  cursor: pointer;
  display: inline-block;
  height: 25px;
  width: 60px;
  margin-top: 2px;
  margin-bottom: 0px;
  margin-left: 1px;
}

.div-color {
  background-color: #fff;
  border-radius: 5px;
  width: 100%;
  padding: 0px 0px 0px 0px;
}

.div-button {
  display: inline-block;
  color: #444;
  border: 1px solid #4b78be;
  background: #fff;
  cursor: pointer;
  vertical-align: middle;
  width: 100%;
  padding: 15px 5px;
  border-radius: 0.3rem !important;
}

/*.div-button:active {
    color:red;
    box-shadow: 0 0 5px -1px rgba(0,0,0,0.6);
}*/

.world-area-text {
  margin-left: -5px;
  color: #4b78be;
}

.small-text {
  margin-top: -6px;
  color: #4b78be;
}

.small-text-middle {
  margin-right: -30px;
}

.small-text-last {
  margin-right: -30px;
}

.row-bottom {
  margin-bottom: 5px;
}

.row-bottom-tf {
  margin-bottom: 8px;
}

.btn-right {
  margin-right: 10px;
}

.btn-bottom {
  margin-bottom: 10px;
}

.col-width {
  width: 100px;
}

.col-width-d {
  width: 100px;
}

.col-width-m {
  width: 100px;
}

.col-width-y {
  width: 120px;
}

.globle-icon {
  margin-left: 12px;
  color: #4b78be;
  margin-top: 4px;
}

.form-group-bottom {
  margin-bottom: 0rem;
}

.modal-footer {
  display: none !important;
}

@media (max-width: 480px) {
  .agreement-validation-custom {
    margin-top: 10px !important;
  }
}

@media (max-width: 769px) {

  .label-name {
    margin-bottom: 25px;
    margin-top: 5px;
  }

  .label-name-cover {
    margin-bottom: 25px;
    margin-top: 5px;
  }

  .label-align {
    text-align: left;
  }

  .btn-right {
    margin-right: 9px;
  }

  .world-area-button {
    width: 100%;
    margin-bottom: 15px;
  }

  .world-area-button {
    width: 100%;
    margin-bottom: 10px;
    margin-right: 0px;
  }

  img {
    width: 98px;
  }

  .btn-sq {
    width: 96px !important;
  }

  .btn-sqw {
    width: 96px !important;
  }

  span.world {
    margin-left: 16px;
  }

  .col-width-d {
    width: 108px;
    margin-right: -22px;
  }

  .col-width-m {
    width: 108px;
    margin-right: -22px;
  }

  .col-width-y {
    width: 108px;
  }
}
</style>
